module.exports = __webpack_public_path__ + "img/FR41919.b2ab7bfc.png";